/**
 * Cmd+S (Ctrl+S elsewhere) in the editor saves now, as leaving the tab does, instead of opening the browser's
 * "Save page as…" over a workbook that saves itself. Without Shift or Alt: those combinations are other commands.
 */
export function isSaveShortcut(event: Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'altKey' | 'shiftKey'>): boolean {
  return (event.metaKey || event.ctrlKey) && !event.altKey && !event.shiftKey && event.key.toLowerCase() === 's';
}
